// ios小程序支付成功后状态检测
// var PaymentGuideManager = require("activity/IosPaymentGuide/PaymentGuideManager")
const STORAGE_KEY = "IOS_PAYMENT_ORDERID"
IosPayStatusCheckUtil = xClass("IosPayStatusCheckUtil")

function readStorage() {
    let s = cc.sys.localStorage.getItem(STORAGE_KEY);
    if (s) {
        try {
            s = JSON.parse(s);
        } catch (e) {
            s = null;
        }
    }
    return s;
}

IosPayStatusCheckUtil.check = function (login) {
    
    var self = this
    console.log("iospay IosPayStatusCheckUtil checkpayment", login)


    function checkOrder(){
        // console.log("iospay checktime " + index)
        function onSuccess(resp) {
            cc.log("iospay IosPayStatusCheckUtil checksuccess resp.data: ", resp.data, data.orderId)
            let status = resp.data.status
            for(index in status){
                let order = status[index]
                // console.log("iospay perorder", order)
                if (order.orderId == data.orderId && order.status == 3){
                    Toast.make("恭喜购买" + data.name + "成功!")
                    cc.sys.localStorage.removeItem(STORAGE_KEY);
                    // // 格子广告用
                    // MetaManager.getInstance().gridAdConfig.pay30day = true;
                    // MetaManager.getInstance().interstitialAdConfig.pay30day = true;
                    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame && (DnSdkTool.getInstance().isOpenAllReport() || UserManager.getInstance().getIosPayType() == "mini")) {
                        let money = data.money || 0;
                        DnSdkTool.getInstance().onPurchase(money * 100);
                    }

                    DCAssist.dc4IosGetCashGoods(data.dcSession, data.dcScence, data.dcGoodsId, data.dcEntry, data.money, data.orderId, data.dcCashData) 

                    // DCAssist.dc4UseCurrencyWin32(data.dcGoodsId, 1, data.dcSource, data.money * 100, data.orderId) //source作为sceneName传入 应要求 scene source module  等都最后记录到category中
                    
                    //登录时走进checkorder，不需addprop
                    if (login){
                        UserDeal.getInstance().deliverGoods(data.dcGoodsId, 1, data.dcSource, {"trade_id": data.orderId, "item_worth": ItemWorth.RMB}, null, true);
                    }else {
                        UserDeal.getInstance().deliverGoods(data.dcGoodsId, 1, data.dcSource, {"trade_id": data.orderId, "item_worth": ItemWorth.RMB});
                    }

                }else if (order.orderId == data.orderId && order.status == 0){
                    //不存在的订单移除
                    cc.sys.localStorage.removeItem(STORAGE_KEY);
                }
            }
        }
        let http = WechatgmaeCheckOrderHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        // http.addEventListener(Events.kError, payFail)
        // http.addEventListener(Events.kCancel, payFail)
        http.load(data.orderId)
    }
    let data = readStorage()
    if (data && !global.iosPaymentTimer){
        checkOrder()
    }
    
    return true

}
module.exports = IosPayStatusCheckUtil
